import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  editAssetAxios,
  getCategory,
  getNetwork,
  userAssetSummit,
} from "../Actions/v1/user";
import { isEmpty } from "../Actions/commonFunction";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

function Vacnewcoin() {
  const location = useLocation();
  console.log("🚀 ~ Vacnewcoin ~ location:", location);
  const navigate = useNavigate();
  const { account, coinDetail } = useSelector((state) => state.user);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  let initialData = {
    projectName: "",
    logo: "",
    symbol: "",
    TotalSupply: "",
    MaxSupply: "",
    CirculatingSupply: "",
    mailId: "",
    category: "",
    subcategory: "",
    network: "",
    pairAddress: "",
    shortdescription: "",
    blockExplorer: "",
    whitpaperlink: "",
    git_link: "",
    Twitterlink: "",
  };

  const [formData, setFormData] = useState(initialData);
  console.log("🚀 ~ Vacnewcoin ~ formData:", formData);
  const [stepform, setStepform] = useState(1);
  const [err, setErr] = useState({});
  const [categorylist, setCategorylist] = useState([]);
  const [networklist, setNetworkList] = useState([]);
  const [selCat, setSelCat] = useState("");
  const [selNetwork, setSelNetwork] = useState("");
  const [subCat, setSubCat] = useState([]);
  const [selSubCat, setSelSubCat] = useState("");
  const onchangeFunc = (e) => {
    const { value, name, data } = e.target;
    console.log("e.target-->", e.target);
    setFormData({
      ...formData,
      [name]: value,
      ...(name == "category" ? { subcategory: "" } : {}),
    });
    if (name == "category") {
      setSelCat(data);
      setSelSubCat("");
    }
    if (name == "network") {
      setSelNetwork(data);
    }
    if (name == "subcategory") {
      setSelSubCat(data);
    }
  };

  //Get Category
  const getCategorylist = async () => {
    let resp = await getCategory();
    if (resp?.status) {
      setCategorylist(resp.data);
    }
  };

  const getNetworklist = async () => {
    let resp = await getNetwork();
    if (resp?.status) {
      setNetworkList(resp.data);
    }
  };

  useEffect(() => {
    getNetworklist();
    getCategorylist();
    console.log("coinDetail-->", coinDetail);
    if (!isEmpty(coinDetail)) {
      setFormData({
        ...formData,
        projectName: coinDetail?.name,
        symbol: coinDetail?.symbol,
        tokenDecimal: coinDetail?.decimal,
        network: coinDetail?.value,
        tokenaddress: coinDetail?.tokenAddress,
      });
      setSelNetwork(coinDetail?.data);
    }
  }, []);

  const validation = async () => {
    let error = {};
    console.log("formData-->", formData);
    await Promise.all(
      Object.keys(formData)?.map((val) => {
        if (isEmpty(formData[val])) {
          error[val] = `${val} is required`;
        }
      })
    );
    setErr(error);
    return error;
  };

  const onsummit = async () => {
    let err = await validation();
    console.log("err-->", err);
    console.log("formData-->", formData);
    if (!isEmpty(err)) return toast.error("Field Required");
    let sendData = {};
    let resp;
    if (location?.pathname == "/editrequest") {
      sendData = {
        _id: location?.state?._id,
        application: formData,
      };
      resp = await editAssetAxios(sendData);
    } else {
      sendData = {
        emailid: account?.EmailId,
        type: "crypto",
        application: formData,
      };
      console.log("🚀 ~ onsummit ~ sendData:", sendData);
      resp = await userAssetSummit(sendData);
      console.log("🚀 ~ onsummit ~ resp:", resp);
    }

    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/");
    } else {
      toast.error(resp?.message);
    }
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (isEmpty(coinDetail) && location?.pathname != "/editrequest") {
  //       navigate("/vac-verification");
  //     }
  //   }, 2000);
  // }, [coinDetail]);

  useEffect(() => {
    if (location?.pathname == "/editrequest") {
      console.log("editrequest", location);
      let { files, ...remData } = location?.state?.application;
      setFormData({ ...remData });
      setSelNetwork(location?.state?.network?.name);
      setSelCat(location?.state?.category?.name);
      setSelSubCat(location?.state?.subcategory?.name);
      setSubCat(
        categorylist?.find(
          (val) => val?.name == location?.state?.category?.name
        )?.subcategory
      );
    }
  }, [location]);

  return (
    <div>
      <div>
        {/* <Header /> */}
        <div className="inner_page position-relative pb-5">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5">
            <div className="vac_border position-relative vac_system rounded-3 py-5 px-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={8} xxl={10} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />
                  <div className="vac_border rounded-3 py-5 px-4">
                    <h4 className="fw-600 text-center">
                      New Coin Listing Request Form
                    </h4>
                    <p className="text-center">
                      Submit this form to request the listing of your new coin.
                      If you're looking to update existing coin information,
                      kindly use our dedicated form for updates here.
                    </p>

                    {stepform === 1 && (
                      <>
                        <div className="pt-5">
                          <h4 className="fw-600 text-center">
                            1. Basic Coin/Token Information
                          </h4>
                          <Row className="form_list">
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Coin/Token Name{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="projectName"
                                  onChange={onchangeFunc}
                                  disabled={true}
                                  value={formData?.projectName}
                                  placeholder="Name of the coin/token, e.g. Bitcoin"
                                />
                                <p className="mt-2 mb-0 lightclr">
                                  Kindly adhere to the if your asset falls under
                                  one of the following categories:{" "}
                                </p>
                                <p className="mb-0 lightclr">
                                  - Stablecoins, Wrapped Assets, Bridged Assets,
                                  Merged Assets, Tokenized RWA Assets, Synthetic
                                  Assets, Staked Assets/LSTs/LRTs, and Escrowed
                                  Assets
                                </p>
                                {err?.projectName && <p>{err?.projectName}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Coin/Token Symbol{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="symbol"
                                  disabled={true}
                                  onChange={onchangeFunc}
                                  value={formData?.symbol}
                                  placeholder="Symbol of the coin/token, e.g. BTC"
                                />
                                {err?.symbol && <p>{err?.symbol}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Token Decimal{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="tokenDecimal"
                                  disabled={true}
                                  onChange={onchangeFunc}
                                  value={formData?.tokenDecimal}
                                  placeholder="Decimal of the coin/token, e.g. 18"
                                />
                                {err?.tokenDecimal && (
                                  <p>{err?.tokenDecimal}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Token Contract Address{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="tokenaddress"
                                  disabled={true}
                                  onChange={onchangeFunc}
                                  value={formData?.tokenaddress}
                                  placeholder="Decimal of the coin/token, e.g. 18"
                                />
                                {err?.tokenaddress && (
                                  <p>{err?.tokenaddress}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  ProjectRelation{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="ProjectRelation"
                                  onChange={onchangeFunc}
                                  value={formData?.ProjectRelation}
                                  placeholder="Project Submiter Relation"
                                />
                                <p className="mt-2 mb-0 lightclr">
                                  CEO , EMPLOYEE etc..,
                                </p>
                                {err?.ProjectRelation && (
                                  <p>{err?.ProjectRelation}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Mail Id <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="mailId"
                                  onChange={onchangeFunc}
                                  value={formData?.mailId}
                                  placeholder="Project Submiter Relation"
                                />
                                <p className="mt-2 mb-0 lightclr">
                                  Login mail Id
                                </p>
                                {err?.mailId && <p>{err?.mailId}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Logo(URL) <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="logo"
                                  value={formData?.logo}
                                  onChange={onchangeFunc}
                                  placeholder="URL. Eg:https://cryptologos.cc/logos/bnb-bnb-logo.png"
                                />
                                {err?.logo && <p>{err?.logo}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  TotalSupply <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="TotalSupply"
                                  value={formData?.TotalSupply}
                                  onChange={onchangeFunc}
                                  placeholder="TotalSupply"
                                />
                                {err?.TotalSupply && <p>{err?.TotalSupply}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  MaxSupply <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="MaxSupply"
                                  value={formData?.MaxSupply}
                                  onChange={onchangeFunc}
                                  placeholder="MaxSupply"
                                />
                                {err?.MaxSupply && <p>{err?.MaxSupply}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  pairAddress <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="pairAddress"
                                  value={formData?.pairAddress}
                                  onChange={onchangeFunc}
                                  placeholder="pairAddress"
                                />
                                {err?.pairAddress && <p>{err?.pairAddress}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Short Description{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="shortdescription"
                                  value={formData?.shortdescription}
                                  onChange={onchangeFunc}
                                  placeholder="shortdescription"
                                />
                                {err?.shortdescription && (
                                  <p>{err?.shortdescription}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  CirculatingSupply{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="CirculatingSupply"
                                  onChange={onchangeFunc}
                                  value={formData?.CirculatingSupply}
                                  placeholder="Symbol of the coin/token, e.g. BTC"
                                />
                                {err?.CirculatingSupply && (
                                  <p>{err?.CirculatingSupply}</p>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>
                                  Website URL <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="blockExplorer"
                                  value={formData?.blockExplorer}
                                  onChange={onchangeFunc}
                                />
                                {err?.blockExplorer && (
                                  <p>{err?.blockExplorer}</p>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Git Link </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="git_link"
                                  value={formData?.git_link}
                                  onChange={onchangeFunc}
                                />
                                {err?.git_link && <p>{err?.git_link}</p>}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Twitter Link </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="Twitterlink"
                                  value={formData?.Twitterlink}
                                  onChange={onchangeFunc}
                                />
                                {err?.Twitterlink && <p>{err?.Twitterlink}</p>}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Whitepaper Link </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="whitpaperlink"
                                  value={formData?.whitpaperlink}
                                  onChange={onchangeFunc}
                                />
                                <p className="lightclr mt-1 mb-0">
                                  Please include the link to your project
                                  whitepaper
                                </p>
                                {err?.whitpaperlink && (
                                  <p>{err?.whitpaperlink}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Category</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    console.log("e-->", e);
                                    onchangeFunc({
                                      target: {
                                        name: "category",
                                        value: e.split(",")[0],
                                        data: e.split(",")[1],
                                      },
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {selCat == "" ? "Select Category" : selCat}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {categorylist?.map((val) => (
                                      <Dropdown.Item
                                        onClick={() =>
                                          setSubCat(val?.subcategory)
                                        }
                                        eventKey={`${val?._id},${val.name}`}
                                      >
                                        {val?.name}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {err?.category && <p>{err?.category}</p>}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Sub Category</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    console.log("e-->", e);
                                    onchangeFunc({
                                      target: {
                                        name: "subcategory",
                                        value: e.split(",")[0],
                                        data: e.split(",")[1],
                                      },
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {selSubCat == ""
                                      ? "Select Sub Category"
                                      : selSubCat}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {subCat?.map((val) => (
                                      <Dropdown.Item
                                        eventKey={`${val?._id},${val.name}`}
                                      >
                                        {val?.name}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {err?.subcategory && <p>{err?.subcategory}</p>}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Network</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    onchangeFunc({
                                      target: {
                                        name: "network",
                                        value: e.split(",")[0],
                                        data: e.split(",")[1],
                                      },
                                    });
                                  }}
                                  disabled={true}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {selNetwork == ""
                                      ? "Select Network"
                                      : selNetwork}
                                  </Dropdown.Toggle>
                                </Dropdown>
                                {err?.network && <p>{err?.network}</p>}
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <hr className="reqhr"></hr>
                        <div className="d-flex mt-3">
                          <button
                            className="clearbtn py-2 me-3"
                            onClick={() => setFormData({})}
                          >
                            Clear Form
                          </button>
                          <button
                            className="themebtn py-2"
                            onClick={() => onsummit()}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default Vacnewcoin;
